import { makeStyles } from '@mui/styles'
import { textAlign } from '@mui/system'

const useStyles = makeStyles((theme) => ({
    titleBox: {
        fontWeight: 600,
        fontStyle: 'normal',
        letterSpacing: '0px',
        color: '#69716F',
        opacity: 1,
    },
    contentBox: {
        font: 'normal normal normal 16px/24px Arial',
        letterSpacing: '0px',
        color: '#898B8B',
        opacity: 1,
    },
    link: {
        color: 'black',
    },
    formLabelBlock: {
        display: 'block',
    },
    formSubLabelBlock: {
        fontSize: '0.7rem !important',
        marginTop: '0px !important',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    icon: {
        display: 'none !important',
        webkitAppearance: 'none',
        mozAppearance: 'none',
    },
    modal: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
    },
    dialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& h2': {
            paddingLeft: '20px',
        },
    },
    longLabelText: {
        alignItems: 'center',
        '& .MuiFormLabel-root': {
            marginTop: '0 !important',
            whiteSpace: 'normal !important',
        },
    },
    informModal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiPaper-root': {
            maxWidth: '690px',
            padding: '20px 20px 40px',
            textAlign: 'center',
        },
    },
}))

export default useStyles
